import { ConfigRepositoryParameters } from '../../../configParametersRepository/types';
import {
  setBuyPathParam,
  setClientIdParam,
  setMktTrackParam,
} from './customDimensions';
import { handleConsent } from './consent';
import { getDefaultCustomDimensions } from './defaultDimensions';
import { createConfigParametersRepository } from '../../../configParametersRepository';
import { SetCustomDimensionOrParam } from '../../types';
import { recoverStoredEvents } from '../../thirdPartyTrackingAgent/eventStore';
import { createRuntimeState } from '../../../configParametersRepository/state';

export const setParams = (params: SetCustomDimensionOrParam) => {
  const { getTrackingStorageClient } = createConfigParametersRepository();
  const storageClient = getTrackingStorageClient();
  const { value } = params;
  if ('customParam' in params) {
    storageClient?.updateCustomParamsAndDimensions({
      [params.customParam]: value,
    });
    return;
  }
  const dimensionName = `dimension${params.customDimension}`;
  storageClient?.updateCustomParamsAndDimensions({
    [dimensionName]: value,
  });
};

export const setupAnalyticsSession = async () => {
  const { getTrackingStorageClient, getStoredParameters } =
    createConfigParametersRepository();
  const configParameters: ConfigRepositoryParameters = getStoredParameters();
  const storageClient = getTrackingStorageClient();
  setMktTrackParam();
  setBuyPathParam();
  setClientIdParam();
  await getDefaultCustomDimensions(configParameters);
  storageClient?.setInStorage(
    'sessionStorage',
    'hasToRemoveUtmParameters',
    true
  );
};

export const initGoogleAnalytics = async () => {
  await setupAnalyticsSession();
  recoverStoredEvents();
  handleConsent();
};

let deferredPromise: Promise<void> | null = null;
export const checkGaInit = async () => {
  const { getTrackingStorageClient, getGenericParameters } =
    createConfigParametersRepository();
  const storageClient = getTrackingStorageClient();
  const { visitID } = getGenericParameters();
  const { getRuntimeState } = createRuntimeState();
  const { isStorageInitialized } = getRuntimeState();
  if (deferredPromise) {
    return deferredPromise;
  }
  if (!isStorageInitialized) {
    storageClient?.initThirdParty(visitID);
  }
  deferredPromise = initGoogleAnalytics();
  await deferredPromise;
};

/**
 * For testing purposes only
 */
export const resetDeferredPromise = () => {
  deferredPromise = null;
};
